import PageWithHeaderLayout from '@/app/layouts/PageWithHeader.layout';
import { bottomSheetTypes, useBoundStore } from '@/shared/store';

import StationInfoContent from './StationInfoContent';

const StationInfoPage = () => {
	const dispatch = useBoundStore((store) => store.dispatch);

	return (
		<PageWithHeaderLayout
			title="주유소 상세"
			showBackButton
			onClickBackButton={() => dispatch({ type: bottomSheetTypes.back })}
		>
			<StationInfoContent />
		</PageWithHeaderLayout>
	);
};

export default StationInfoPage;
